// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrBtn[data-v-1bb773d3]{border-radius:15px!important;-webkit-box-shadow:8px 5px 10px rgba(2,16,92,.5490196078431373);box-shadow:8px 5px 10px rgba(2,16,92,.5490196078431373);cursor:pointer}.qrBtn[data-v-1bb773d3]:hover{border-radius:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}", ""]);
// Exports
module.exports = exports;
